const FinmoPayinStatus = {
  pending: 'PENDING',
  completed: 'COMPLETED',
  expired: 'EXPIRED',
  cancelled: 'CANCELLED',
};

export default FinmoPayinStatus;
